import { IconButton, InputRightElement } from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";

function PasswordVisibilityToggle({ isVisible, onToggle }) {
  const { t } = useTranslation("common");

  return (
    <InputRightElement width="2.75rem">
      <IconButton
        aria-label={
          isVisible ? t("hidePasswordButtonText") : t("showPasswordButtonText")
        }
        icon={isVisible ? <ViewOffIcon /> : <ViewIcon />}
        variant="ghost"
        size="sm"
        minW="auto"
        h="1.75rem"
        onClick={onToggle}
        color="gray.500"
        _hover={{ color: "teal.600", bg: "transparent" }}
      />
    </InputRightElement>
  );
}

export default PasswordVisibilityToggle;
